module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_1-39c5b0186dc5bd132a4910f024365c49.jpg";